import React, { Component } from "react";
import { Helmet } from "react-helmet";

class ContentProjectSyrmaSGS extends Component {
  render() {
    return (
      <div className="detail-gallery">
        <Helmet>
          <title>Chemcoats Project | Syrmasgs</title>
          <meta
            name="description"
            content="Syrma SGS, a prominent motherboard and electronics manufacturing company, required a specialized ESD (Electrostatic Discharge) flooring solution that could provide a highly controlled environment to prevent static build-up, which could potentially damage sensitive electronic components during production."
          />
          <meta name="author" content="Your Company Name" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://www.chemcoats.com/syrmasgs" />
        </Helmet>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={21}
          data-mobile={21}
          data-smobile={21}
        />
        <div
          className="themesflat-gallery style-2 has-arrows arrow-center arrow-circle offset-v-82 has-thumb w185 clearfix"
          data-gap={0}
          data-column={1}
          data-column2={1}
          data-column3={1}
          data-auto="false"
        >
          <div className="owl-carousel owl-theme">
            <div className="gallery-item">
              <div className="inner">
                <div className="thumb">
                  <img
                    src="assets/img/project/Syrma SGS/access-floors23-qfoqdeej9bobsntzfq7m4oa8g1t3nhtlfa4z1wbbdw.png"
                    alt="Syrma-SGS"
                    title="Syrma SGS"
                  />
                </div>
              </div>
            </div>
            <div className="gallery-item">
              <div className="inner">
                <div className="thumb">
                  <img
                    src="assets/img/project/Syrma SGS/access-floors24-qfoqfijgmwkjx2re354e8n2kk9dtyz7upqzaxb6fdw.png"
                    alt="Syrma-SGS"
                    title="Syrma SGS"
                  />
                </div>
              </div>
            </div>
            <div className="gallery-item">
              <div className="inner">
                <div className="thumb">
                  <img
                    src="assets/img/project/Syrma SGS/WhatsApp-Image-2023-11-14-at-8.33.59-PM-1-qfoq92dbqtqq9e4mqurjmrnpu3665qm5htuddyqo2s.jpeg"
                    alt="Syrma-SGS"
                    title="Syrma SGS"
                  />
                </div>
              </div>
            </div>
            <div className="gallery-item">
              <div className="inner">
                <div className="thumb">
                  <img
                    src="assets/img/project/Syrma SGS/WhatsApp-Image-2023-11-14-at-8.34.00-PM-1-qfoqjfj941xkal2l7u2fmnhpo22w1krl94u4wtddgk.jpeg"
                    alt="Syrma-SGS"
                    title="Syrma SGS"
                  />
                </div>
              </div>
            </div>
            <div className="gallery-item">
              <div className="inner">
                <div className="thumb">
                  <img
                    src="assets/img/project/Syrma SGS/WhatsApp-Image-2023-11-14-at-8.34.00-PM-qfoqi7cu6u934wurdsyyvgn1qy4mzsw7f26bct6vl0.jpeg"
                    alt="Syrma-SGS"
                    title="Syrma SGS"
                  />
                </div>
              </div>
            </div>{" "}
            <div className="gallery-item">
              <div className="inner">
                <div className="thumb">
                  <img
                    src="assets/img/project/Syrma SGS/WhatsApp-Image-2023-11-14-at-8.34.42-PM-qfoql5kln4ahkukh5kvt77u4vhl45llvhnw6l2te1w.jpeg"
                    alt="Syrma-SGS"
                    title="Syrma SGS"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /.themesflat-cousel-box */}
        <div
          className="themesflat-spacer clearfix"
          data-desktop={40}
          data-mobile={40}
          data-smobile={40}
        />
        <div className="flat-content-wrap style-3 clearfix">
          <h5 className="title">PROJECT DESCRIPTION</h5>
          <div className="sep has-width w60 accent-bg margin-top-18 clearfix" />
          <p className="margin-top-28">
            {/* Syrma SGS, a prominent motherboard and electronics manufacturing
            company, required a specialized ESD (Electrostatic Discharge)
            flooring solution that could provide a highly controlled environment
            to prevent static build-up, which could potentially damage sensitive
            electronic components during production. To ensure the integrity of
            their high-tech manufacturing processes, Syrma SGS sought a flooring
            solution that would adhere precisely to the most stringent industry
            standards, including IEC 61340 and ANSI 2020 standards, which are
            internationally recognized for their effectiveness in managing
            electrostatic discharge in electronic manufacturing environments. */}
            Syrma SGS, a leading motherboard and electronics manufacturing
            company, needed an advanced static-discharge (ESD) flooring solution
            that would allow precise control of the ESD environment to avoid
            electrostatic discharge (ESD), which could lead to damage of
            electronic components under production. In order to verify the
            reliability of their advanced manufacturing processes, Syrma SGS
            purchased a flooring solution that would conform to the most
            exacting industry standards (including IEC 61340 and ANSI 2020
            standards, which are the most recognized internationally for
            mitigating electrostatic discharge in the electronic manufacturing
            environment).
          </p>
          <p>
            Recognizing the critical importance of this requirement, we, a team,
            partnered closely with Syrma SGS to develop and install an{" "}
            <a
              href="https://www.chemcoats.com/esd-flooring"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "underline" }}
            >
              ESD flooring
            </a>{" "}
            platform, and all its pertinent specifications, i.e., conductivity,
            durability, and safety. The flooring solution that we offered was
            not just in accordance with IEC 61340 (defining the principles of
            ESD control in sensitive electronic environment) but also in line
            with the new ANSI 2020 requirements, keeping it up to date with the
            recent industry standard.
          </p>

          <p>
            {/* By providing this highly controlled static current floor, we ensured
            that Syrma SGS could maintain a safe and efficient manufacturing
            process for their sensitive electronic components, eliminating the
            risk of electrostatic discharge damage. The successful
            implementation of this flooring solution demonstrated our ability to
            deliver custom, high-performance solutions that meet the most
            exacting standards in the electronics industry, ensuring compliance
            with industrial safety requirements while enhancing the overall
            operational efficiency of the facility. */}
            In doing so, we provided this extremely controlled static current
            floor and thereby allowed Syrma SGS to produce safe and effective
            manufacturing process for their delicate electronic items without
            electrostatic discharge damage. The successful deployment of this
            floor covering solution illustrated our capability to provide
            tailored, high-performance solutions which conform to the highest
            standards in the industry of electronics, ensuring industrial safety
            compliance and improving the overall facility operational
            effectiveness.
          </p>
        </div>
      </div>
    );
  }
}

export default ContentProjectSyrmaSGS;
